import { createContext, useContextSelector } from '@fluentui/react-context-selector';
const defaultContextValue = {
  open: false,
  modalType: 'modal',
  isNestedDialog: false,
  dialogRef: {
    current: null
  },

  requestOpenChange() {
    /* noop */
  }

}; // Contexts should default to undefined

export const DialogContext = /*#__PURE__*/createContext(undefined);
export const DialogProvider = DialogContext.Provider;
export const useDialogContext_unstable = selector => useContextSelector(DialogContext, (ctx = defaultContextValue) => selector(ctx));
//# sourceMappingURL=dialogContext.js.map